export const APP_BLACKLIST_GRACE_DAYS = 14;

export function formatBlacklistExpiry(blacklistExpiresAt) {
  if (!blacklistExpiresAt) return null;
  const date = new Date(blacklistExpiresAt);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("de-DE", { dateStyle: "medium" });
}

export function appStatusLabel(app) {
  if (app.blacklisted) {
    const until = formatBlacklistExpiry(app.blacklistExpiresAt);
    return until ? `Blacklist · bis ${until}` : "Blacklist";
  }
  if (app.disabled) return "Deaktiviert";
  if (app.installing) return "Wird installiert";
  if (app.assigned && app.installed) return "Zugewiesen · installiert";
  if (app.assigned) return "Zugewiesen · nicht installiert";
  if (app.installed) return "Installiert";
  return "—";
}

export function appStatusClass(app) {
  if (app.blacklisted) return "text-bg-warning";
  if (app.disabled) return "text-bg-warning";
  if (app.installing) return "text-bg-warning";
  if (app.assigned && app.installed) return "text-bg-success";
  if (app.assigned) return "text-bg-danger";
  return "text-bg-secondary";
}

export function licenseStatusLabel(row) {
  if (row.blacklisted) {
    const until = formatBlacklistExpiry(row.blacklistExpiresAt);
    return until ? `Blacklist · bis ${until}` : "Blacklist";
  }
  if (row.disabled) return "Deaktiviert";
  return "Aktiv";
}

export function licenseStatusClass(row) {
  if (row.blacklisted) return "text-bg-warning";
  if (row.disabled) return "text-bg-warning";
  return "text-bg-success";
}
